import React from 'react';
import { twMerge } from 'tailwind-merge';

interface IconComponentProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  width?: string;
  height?: string;
  fill: string;
  stroke?: string;
  hoverFill?: string;
  hoverStroke?: string;
  className?: string;
}

const IconComponent: React.FC<IconComponentProps> = ({
  icon: IconComponent,
  width = 'w-auto desktop:w-6',
  height = 'h-auto desktop:h-6',
  fill,
  stroke,
  hoverFill,
  hoverStroke,
  className,
}) => {
  return (
    <IconComponent
      className={twMerge(
        `${width} ${height} flex-shrink-0 ${fill} ${stroke} hover:${hoverFill} hover:${hoverStroke}`,
        className,
      )}
    />
  );
};

export default IconComponent;
